import AdministracionEntradaMaquila from "components-base/pages/administracionEntradaMaquila";
const EntradaMaquila = () => {
    return (
        <div className="flex w-full flex-col gap-5">
            <AdministracionEntradaMaquila />
        </div>
    );
}
export default EntradaMaquila;